import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

const AVISO_LEGAL = {
  title: "Aviso Legal",
  intro: "En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa que los datos identificativos de la empresa son:",
  dataBlock: [
    ["Nombre comercial", "SALUD Y VISIÓN"],
    ["Denominación social", "CENTRO DE OPTOMETRÍA SALUD Y VISIÓN S.L."],
    ["CIF", "B84738897"],
    ["Domicilio social", "Alcalde López Casero 10, Madrid, España"],
    ["Email", "centrodeoptometriasaludyvision@gmail.com"],
  ],
  sections: [
    {
      t: "1. Propiedad intelectual",
      p: "Todos los contenidos de este sitio web, incluyendo textos, gráficos, imágenes, logos, iconos, software, bases de datos, y otros contenidos protegidos por derechos de propiedad intelectual son propiedad exclusiva de SALUD Y VISIÓN. Está prohibido el uso no autorizado de cualquier contenido protegido por derechos de autor.",
    },
    {
      t: "2. Uso del sitio web",
      p: "El acceso y uso de este sitio web están sujetos a los términos y condiciones que se describen a continuación. Al acceder a este sitio web, usted acepta estos términos y condiciones sin limitación ni reserva.",
    },
    {
      t: "3. Responsabilidad legal",
      p: "La información contenida en este sitio web se proporciona «tal cual» y sin garantía de ningún tipo, ya sea expresa o implícita. SALUD Y VISIÓN no asume ninguna responsabilidad por cualquier pérdida o daño que pueda resultar del uso de este sitio web o de la información contenida en él.",
    },
    {
      t: "4. Protección de datos personales",
      p: "SALUD Y VISIÓN cumple con las leyes de protección de datos personales y se compromete a proteger la privacidad de los usuarios de este sitio web. Consulte nuestra Política de Privacidad para obtener más información sobre cómo tratamos los datos personales de los usuarios.",
    },
    {
      t: "5. Jurisdicción",
      p: "Este sitio web y su contenido se rigen por las leyes españolas. Cualquier disputa que surja en relación con este sitio web se someterá a la jurisdicción exclusiva de los tribunales de Valencia, España. En caso de cualquier duda o consulta sobre este aviso legal, puede ponerse en contacto con nosotros a través de la dirección de correo electrónico centrodeoptometriasaludyvision@gmail.com.",
    },
  ],
};

const COOKIES = {
  title: "Política de Cookies",
  intro: "Este sitio web, al igual que la mayoría de los sitios en Internet, usa Cookies para mejorar y optimizar la experiencia del usuario. A continuación encontrará información detallada sobre qué son las «Cookies», qué tipología utiliza este sitio web, cómo puede desactivarla en su navegador y cómo bloquear específicamente la instalación de Cookies de terceros.",
  sections: [
    {
      t: "¿Qué son las Cookies y cómo las utilizan los sitios web de SALUD Y VISIÓN?",
      p: "Las Cookies son archivos que el sitio web o la aplicación que utilizas instala en su navegador o en su dispositivo (Smartphone, tableta o televisión conectada) durante su recorrido por las páginas o por la aplicación, y sirven para almacenar información sobre su visita. Como la mayoría de los sitios en Internet, los portales web de SALUD Y VISIÓN utilizan Cookies para asegurar que las páginas web pueden funcionar correctamente, almacenar sus preferencias (idioma, tamaño de letra), conocer su experiencia de navegación y recopilar información estadística anónima.\n\nLas Cookies se asocian únicamente a un usuario anónimo y su ordenador/dispositivo, y no proporcionan referencias que permitan conocer datos personales. En todo momento podrá acceder a la configuración de su navegador para modificar y/o bloquear la instalación de las Cookies enviadas por los sitios web de SALUD Y VISIÓN, sin que ello impida el acceso a los contenidos (aunque la calidad del funcionamiento puede verse afectada).",
    },
    {
      t: "¿Por qué son importantes?",
      list: [
        "Desde un punto de vista técnico, permiten que los sitios web funcionen de forma más ágil y adaptada a las preferencias de los usuarios.",
        "Establecen niveles de protección y seguridad que impiden o dificultan ciberataques contra el sitio web o sus usuarios.",
        "Permiten conocer datos estadísticos recopilados en las Cookies para mejorar la calidad y experiencia del servicio.",
        "Sirven para optimizar la publicidad que mostramos a los usuarios, ofreciendo la que más se ajusta a sus intereses.",
      ],
    },
    {
      t: "Tipos de Cookies que utilizamos",
      list: [
        "De sesión: expiran cuando el usuario abandona la página o cierra el navegador.",
        "Permanentes: expiran cuando se cumple el objetivo para el que sirven o cuando se borran manualmente.",
        "Propias: enviadas y gestionadas exclusivamente por nosotros para el mejor funcionamiento del sitio.",
        "De terceros: establecidas por un dominio diferente de nuestro sitio web (por ejemplo, al interactuar con redes sociales o vídeos externos).",
      ],
      p: "Algunos servicios de SALUD Y VISIÓN pueden utilizar conectores con redes sociales (Facebook, Twitter, Google+, LinkedIn, etc.). Al utilizar el registro social, autoriza a la red social a almacenar una Cookie persistente que recuerda su identificación en el servicio. Puede eliminarla y anular los permisos desde la configuración de privacidad de la red social concreta.",
    },
    {
      t: "¿Cómo puedo configurar mis Cookies?",
      p: "Al navegar y continuar en nuestro sitio web estará consintiendo el uso de las Cookies en las condiciones contenidas en esta Política. Puede bloquearlas o deshabilitarlas activando la configuración de su navegador. Si las rechaza podrá seguir usando nuestro sitio web, aunque algunos servicios podrán ser limitados.",
    },
    {
      t: "Actualizaciones de la Política de Cookies",
      p: "Es posible que actualicemos esta Política de Cookies. Le recomendamos revisarla cada vez que acceda al sitio web para estar informado sobre cómo y para qué usamos las cookies.",
    },
  ],
};

const PRIVACIDAD = {
  title: "Política de Privacidad",
  intro: "CENTRO DE OPTOMETRÍA SALUD Y VISIÓN S.L. (en adelante SALUD Y VISIÓN), en cumplimiento del Reglamento Europeo 2016/679 de 27 de abril de 2016 (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), desea poner en conocimiento de aquellas personas que voluntariamente utilizan los formularios para contratar con SALUD Y VISIÓN cualquiera de los servicios ofrecidos, la política llevada a cabo respecto al tratamiento y protección de sus datos personales.",
  sections: [
    {
      t: "1. Identificación del responsable del tratamiento",
      p: "SALUD Y VISIÓN, con domicilio en C/ Alcalde López Casero 10, 28027 Madrid. Teléfono 91 404 48 77. CIF: B84738897. Inscrita en el Registro Mercantil de Madrid, Tomo 41, Folio 11, Hoja 970. Es titular de la web www.saludyvision.es y responsable de los tratamientos de datos personales de clientes, destinatarios de campañas y personas de contacto.",
    },
    {
      t: "2. Actualización de las políticas",
      p: "SALUD Y VISIÓN podrá modificar la presente política siempre que sea necesario para adecuarla a cambios legislativos, reglamentarios, jurisprudenciales o administrativos. Cualquier modificación será publicada. Recomendamos la lectura periódica de estas políticas.",
    },
    {
      t: "3. Finalidad del tratamiento",
      p: "La comunicación de datos personales por los clientes tendrá lugar cuando voluntariamente utilicen los formularios para ponerse en contacto con SALUD Y VISIÓN. Las finalidades del tratamiento son:",
      list: [
        "a) Cumplimiento de contrato: gestiones administrativas, contables, fiscales y logísticas vinculadas al servicio de optometría y terapia visual, gestión de agenda y atención a peticiones.",
        "b) Con su consentimiento: campañas promocionales, newsletters, comunicaciones comerciales, invitaciones a eventos o encuestas (retirable en cualquier momento).",
        "c) Por interés legítimo: mejorar la experiencia del cliente, comunicaciones de cortesía (felicitaciones, aniversarios) y análisis estadísticos anónimos.",
      ],
    },
    {
      t: "4. Duración del tratamiento",
      p: "SALUD Y VISIÓN conservará sus datos personales mientras dure la relación contractual. Una vez finalizada, los datos serán conservados debidamente bloqueados durante los plazos de prescripción legal (con carácter general 10 años). Una vez finalizados, los datos serán destruidos o borrados.",
    },
    {
      t: "5. Lugar del tratamiento",
      list: [
        "Centros de Proceso de Datos: Facebook Inc. (EE.UU.), Twitter X Inc. (EE.UU.), Google LLC (EE.UU.) — todos con Cláusulas contractuales estándar (SCC) como garantía.",
        "Proveedor cloud 1&1 Internet SE, en Alemania.",
        "Sede principal de SALUD Y VISIÓN en Madrid, España.",
      ],
      p: "Los datos son tratados por personal técnico de SALUD Y VISIÓN y por eventuales encargados externos para mantenimiento. No hay previsión de transferencias de datos a países terceros.",
    },
    {
      t: "6. Consentimiento",
      p: "Al enviar un correo electrónico o comunicación a SALUD Y VISIÓN indicando sus datos personales, el cliente da su consentimiento libre, inequívoco, específico, informado y expreso para el tratamiento de sus datos.\n\nUsuarios menores de edad: SALUD Y VISIÓN no permite ninguna operación con los datos personales de menores de edad. El registro está permitido solamente a usuarios mayores de edad.",
    },
    {
      t: "7. Registro en la Web",
      p: "Para el disfrute de servicios reservados (newsletter, listado de favoritos, etc.), el usuario debe registrarse. Algunos datos son obligatorios (por ejemplo, email para recibir newsletters); otros son opcionales. No facilitar ciertos datos puede limitar el acceso a determinados servicios.",
    },
    {
      t: "8. Destinatarios de cesiones o acceso a datos",
      p: "SALUD Y VISIÓN prevé comunicaciones de datos con:",
      list: [
        "Administraciones Públicas, Jueces, Ministerio Fiscal, Tribunales, etc., cuando así lo exija la legislación.",
        "Entidades financieras para gestión de cobros por tarjeta y domiciliaciones.",
        "Empresas informáticas para soporte y mantenimiento, gestoría para administración y contabilidad y otros profesionales necesarios para la prestación del servicio.",
        "Fabricantes, mayoristas y distribuidores oficiales de los productos comercializados (para registro y gestión de garantías).",
      ],
    },
    {
      t: "9. Calidad de los datos",
      p: "Ningún cliente puede utilizar la identidad de otra persona. Los datos comunicados deben ser propios, adecuados, pertinentes, actuales, exactos y verdaderos. El cliente será responsable ante cualquier daño causado a terceros o a SALUD Y VISIÓN por el uso de datos personales falsos, erróneos o de un tercero sin autorización.",
    },
    {
      t: "10. Ejercicio de derechos",
      p: "Puede ejercitar de forma gratuita sus derechos de acceso, oposición, rectificación, cancelación, supresión, limitación del tratamiento, no ser objeto de decisiones individuales automatizadas y portabilidad de los datos, enviando un documento firmado digitalmente o aportando una copia de un documento acreditativo de identidad a: C/ Alcalde López Casero 10, 28027 Madrid, o por email a optica@saludyvision.es.",
      list: [
        "Acceso: consultar sus datos personales.",
        "Rectificación: modificar sus datos cuando sean inexactos.",
        "Supresión: solicitar la eliminación de sus datos.",
        "Oposición: solicitar que no se traten sus datos.",
        "Limitación del tratamiento: en los casos previstos por la ley.",
        "Decisiones individuales automatizadas: no ser objeto de una decisión basada únicamente en tratamiento automatizado.",
        "Portabilidad: recibir sus datos en formato electrónico y transmitirlos a otra entidad.",
      ],
    },
    {
      t: "11. Medidas de seguridad",
      p: "SALUD Y VISIÓN ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos y los riesgos a que están expuestos. Se garantiza el deber de secreto profesional respecto de los datos personales de los clientes.\n\nEn caso de disconformidad puede presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
    },
  ],
};

const DOCS = {
  "aviso-legal": AVISO_LEGAL,
  "politica-cookies": COOKIES,
  "politica-privacidad": PRIVACIDAD,
};

const LegalPage = ({ slug }) => {
  const doc = DOCS[slug];
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  if (!doc) return null;

  return (
    <main className="py-16 md:py-20 px-6" data-testid={`legal-${slug}`}>
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 font-sans-body text-sm text-[color:var(--sage-600)] hover:underline mb-8" data-testid="back-home"><ArrowLeft size={15} /> Volver al inicio</Link>

        <div className="flex items-center gap-3 mb-5">
          <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: "var(--sage-500)" }}>
            <FileText size={20} style={{ color: "var(--cream)" }} />
          </div>
          <span className="section-eyebrow">Textos legales</span>
        </div>

        <h1 className="section-title" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.5rem)" }}>{doc.title}</h1>

        <p className="font-sans-body text-[color:var(--ink-soft)] mt-6 leading-relaxed">{doc.intro}</p>

        {doc.dataBlock && (
          <div className="mt-8 p-6 rounded-2xl" style={{ background: "var(--sage-50)", border: "1px solid var(--sage-100)" }}>
            <dl className="space-y-3 font-sans-body text-sm">
              {doc.dataBlock.map(([k, v]) => (
                <div key={k} className="grid md:grid-cols-[180px_1fr] gap-1 md:gap-3">
                  <dt className="font-semibold text-[color:var(--sage-600)]">{k}</dt>
                  <dd className="text-[color:var(--ink)] break-words">{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        )}

        <div className="mt-10 space-y-10">
          {doc.sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl md:text-2xl font-medium" style={{ color: "var(--ink)" }}>{s.t}</h2>
              {s.p && s.p.split("\n\n").map((para, j) => (
                <p key={j} className="font-sans-body text-[color:var(--ink-soft)] mt-4 leading-relaxed whitespace-pre-line">{para}</p>
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2 font-sans-body text-[color:var(--ink-soft)]">
                  {s.list.map((item, j) => (
                    <li key={j} className="flex gap-3 items-start">
                      <span className="font-display shrink-0 mt-0.5" style={{ color: "var(--sage-500)" }}>✦</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--sage-100)] flex flex-wrap gap-3 font-sans-body text-sm">
          <span className="text-[color:var(--ink-soft)]">Ver también:</span>
          {Object.entries(DOCS).filter(([s]) => s !== slug).map(([s, d]) => (
            <Link key={s} to={`/${s}`} className="underline hover:no-underline" style={{ color: "var(--sage-600)" }} data-testid={`legal-link-${s}`}>{d.title}</Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
